




















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import CampaignStatusView from '@/modules/base-campaign/components/shared/CampaignStatusView.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminContentCampaignTabularActions
  from '@/modules/content-campaign/components/admin/AdminContentCampaignTabularActions.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import MediaAttachmentDialog from '@/modules/media/components/shared/MediaAttachmentDialog.vue'
import { invoiceShowTabularColumn } from '@/modules/invoice/models/columns/invoice-show-tabular.column'
import { InvoiceResourceTypeInAdmin } from '@/modules/invoice/models/invoice-reource.model'
import InvoiceStatusView from '@/modules/invoice/components/shared/InvoiceStatusView.vue'
import InvoiceModelTypeView from '@/modules/invoice/components/shared/InvoiceModelTypeView.vue'
import AdminInvoiceActions from '@/modules/invoice/components/admin/table/AdminInvoiceActions.vue'
import InvoicePersonTypeView from '@/modules/invoice/components/shared/InvoicePersonTypeView.vue'
import AdminInvoiceShowTabularActions from '@/modules/invoice/components/admin/AdminInvoiceShowTabularActions.vue'

@Component({
  components: {
    AdminInvoiceShowTabularActions,
    InvoicePersonTypeView,
    AdminInvoiceActions,
    InvoiceModelTypeView,
    InvoiceStatusView,
    MediaAttachmentDialog,
    TabularHeader,
    AdminCampaignStatus: CampaignStatusView,
    DateTooltipped,
    AdminContentCampaignTabularActions,
    TextEllipsis
  }
})
export default class AdminInvoiceShowTabular extends Vue {
  @Prop({ required: true }) invoice: InvoiceResourceTypeInAdmin
  private columnsData = invoiceShowTabularColumn()

  get invoiceData() {
    return this.invoice.data
  }

}
